//USER PERSONAL INFO
export const USER_PERSONAL_INFO_REQUEST = 'USER_PERSONAL_INFO_REQUEST';
export const USER_PERSONAL_INFO_SUCCESS = 'USER_PERSONAL_INFO_SUCCESS';
export const USER_PERSONAL_INFO_FAIL = 'USER_PERSONAL_INFO_FAIL';

//GET USER PERSONAL INFO
export const GET_USER_PERSONAL_INFO_REQUEST = 'GET_USER_PERSONAL_INFO_REQUEST';
export const GET_USER_PERSONAL_INFO_SUCCESS = 'GET_USER_PERSONAL_INFO_SUCCESS';
export const GET_USER_PERSONAL_INFO_FAIL = 'GET_USER_PERSONAL_INFO_FAIL';
